/* eslint-disable no-unused-vars */
export enum AppointmentType {
  NEW = 'new',
  REVIEW = 'review',
}
